<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>
      <div class="info">
        <p class="title">
          {{ $t("recharge.curr_balance") }}({{ $t("reservation.unit") }})
        </p>
        <p class="value">{{ balance }}</p>
      </div>
      <div class="content recharge">
        <van-form @submit="onSubmit">
          <div class="form-item">
            <div class="form-item-title">{{ $t("recharge.input_money") }}</div>
            <div style="height: 65px">
              <van-field
                v-model="money"
                name="money"
                type="number"
                label="MXN"
                :placeholder="$t('recharge.input_money')"
                :rules="moneyRules"
              />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-title">{{ $t("recharge.pay_way") }}</div>
            <div>
              <van-radio-group v-model="pay_way">
                <van-radio name="Mexicopay">MexicoPay</van-radio>
              </van-radio-group>
            </div>
            <div style="margin: 16px">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                :loading="submitting"
                :disabled="submitting"
              >
                {{ $t('recharge.next_step') }}
              </van-button>
            </div>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Form, Field, RadioGroup, Radio, Toast } from "vant";

Vue.use(Form).use(Field).use(RadioGroup).use(Radio).use(Toast);

export default {
  data() {
    return {
      balance: 0,
      pay_way: "Mexicopay",
      money: "",
      personalreport: {},
      submitting: false,
      moneyRules: [
        { required: true, message: "Please enter the recharge amount" },
      ],
    };
  },
  mounted() {
    const balance = this.$route.params.balance;
    this.balance = balance !== undefined && balance !== null ? balance : 0;
  },
  methods: {
    back() {
      return window.history.back();
    },

    getPayUrlFromResponse(res) {
      if (!res || res.code !== 200) {
        return "";
      }
      const data = res.data;
      if (!data) {
        return "";
      }
      if (typeof data === "string") {
        return data;
      }
      return data.pay_url || data.url || "";
    },

    redirectToPay(payUrl) {
      if (payUrl) {
        window.location.href = payUrl;
        return true;
      }
      return false;
    },

    redirectToCustomerService() {
      const service = this.$store.getters.getBaseInfo || {};
      if (Number(service.iskefu) === 1 && service.kefu) {
        window.location.href = service.kefu;
        return true;
      }
      this.$router.push({ path: "/ServiceOnline" });
      return true;
    },

    onSubmit(values) {
      const amount = parseFloat(values.money !== undefined ? values.money : this.money);
      if (!amount || amount <= 0 || Number.isNaN(amount)) {
        this.$toast(this.$t("reservation.money_err"));
        return;
      }
      if (this.submitting) {
        return;
      }
      this.submitting = true;

      this.$http({
        method: "post",
        data: {
          pay_way: this.pay_way,
          money: amount,
        },
        url: "recharge",
      })
        .then((res) => {
          if (!res || typeof res.code === "undefined") {
            this.$toast(this.$t("setting.contact_recharge"));
            this.redirectToCustomerService();
            return;
          }
          const payUrl = this.getPayUrlFromResponse(res);
          if (res.code === 200 && this.redirectToPay(payUrl)) {
            return;
          }
          if (res.code === 200 && !payUrl) {
            this.redirectToCustomerService();
            return;
          }
          this.$toast(res.msg || this.$t("setting.contact_recharge"));
          if (res.code === 401) {
            this.redirectToCustomerService();
          }
        })
        .catch(() => {
          this.$toast(this.$t("setting.contact_recharge"));
          this.redirectToCustomerService();
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getPersonalreport() {
      this.$http({
        method: "get",
        url: "user_get_personalreport",
      }).then((res) => {
        if (res.code === 200) {
          this.personalreport = res.data;
          this.win_money =
            this.personalreport.win_money - this.personalreport.play_money;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getPersonalreport();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .header {
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}
.recharge {
  padding: 10px 30px;
}

.van-cell {
  line-height: 65px !important;
}

.recharge .van-button {
  height: 44px !important;
}
.recharge .van-button__text {
  color: #fff !important;
}

/deep/.van-radio__icon {
  font-size: 30px !important;
}
/deep/.van-radio__label {
  margin-left: 25px !important;
  font-size: 35px !important;
}

/deep/.van-radio {
  height: 65px !important;
}

.form-item {
  margin-top: 40px;
}

.form-item-title {
  font-size: 36px;
  font-weight: bold;
  color: #999;
  margin-bottom: 20px;
}

.recharge span {
  font-size: 4vw;
  color: #868686;
  font-weight: 500;
}

.container .header .info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 10px;
  margin: auto;
}
.container .header .info .title {
  font-size: 25px;
  color: #e5e5e5;
}
.container .header .info .value {
  margin: 10px auto;
  color: #fff;
  font-size: 50px;
  border-bottom: 1px solid #fff;
}
.container .header .info .tip {
  font-size: 30px;
  color: #e5e5e5;
}
.container .content {
  flex: 1;
  background: #f2f2f5;
}
</style>
